import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { Stack, Text } from "@mantine/core";
import type { HubOutletContext } from "../../EnterpriseHub";
import { MultiAppScenario } from "./MultiAppScenario";

// A member with exactly one launchable product skips the hub: the browser goes straight
// to the product. Admins never land here — resolveScenario keeps them on the grid.
export function SingleAppRedirect() {
  const { sections } = useOutletContext<HubOutletContext>();
  const launchable = sections?.active.find(([product]) => !product.requiresOrgAdmin);
  const product = launchable?.[0];
  const href = product?.path;

  useEffect(() => {
    if (href) globalThis.location.assign(href);
  }, [href]);

  // A product with no destination cannot be redirected to — show the grid instead.
  if (!product || !href) return <MultiAppScenario />;

  return (
    <Stack align="center" py={48}>
      <Text fz={'sm'} c={'var(--text-muted)'}>Taking you to {product.name}…</Text>
    </Stack>
  );
}
